<template lang="pug">
  #signUpSuccess
    .container-width.bg-black
      .px-3.py-4.customContainerBorder
        h5.text-center.font-weight-bold.mt-3.pb-5.mb-5
        .icon
          .icon-area
            .icon-success.mx-auto.text-center
              .mb-5
                .action
                  .trophy.mx-auto
                    .circle.mb-5(style='background-color: #000; width: 80px; height: 80px;')
                      img(
                        :src='okImg',
                        alt='success_ok_img'
                        style='width: 40px;'
                      )
        .text-center
          p(
            v-if="singUpAndBindSa"
          ) 會員開通成功且已綁定顧問成功!
          p(
            v-else
          ) 會員綁定成功 !
          small.mt-3(style='color:#AEAEAE') 我們將不定期提供最新會員活動相關訊息。
        .row.p-3.pt-5.mx-2
          .col-12
            button.button.btn-block.button_clickCustom.button_clickCustom-outline-primary(
              type="button",
              @click="backToLINEHandler()"
            ) 返回官方帳號
</template>

<script>
import okImgUrl from '@/assets/images/icon/icon_ok.png';

export default {
  name: 'memberSuccess',
   props: {
    // 是否綁定成功且順便綁定顧問了
    singUpAndBindSa: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      okImg: okImgUrl
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  }
};
</script>

<style lang="scss" scoped>
.customContainerBorder {
  border-top-left-radius: 50px;
  background-color: #FFF;
}
.container-width {
  width: 100%;
}
.border-sticker {
  border: 3px solid #000;
}
.border-thin {
  border: 2px solid #000;
}
.button_clickCustom {
  background-color: #000;
  color: #FFF;
}

</style>
